import { AfterViewInit, Component, Input, NgZone, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { SharedComponentsModule } from '../../shared/module/shared-components.module';
import { HighchartsOptions } from '../../shared/component/pie-chart-simple/highcharts-common/highcharts-global-const';

@Component({
  selector: 'app-base-chart',
  standalone: true,
  imports: [SharedComponentsModule],
  templateUrl: './base-chart.component.html',
  styleUrl: './base-chart.component.scss',
})
export class BaseChartComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() chartId: string;
  @Input() options: HighchartsOptions;

  chartInstance: Highcharts.Chart;
  showEmptyState = true;

  constructor(private zone: NgZone) {}

  ngAfterViewInit(): void {
    this.checkEmptyState();
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options) {
      this.options.credits = {
        enabled: false,
      };
      this.options.plotOptions = {
        ...this.options.plotOptions,
        series: {
          ...(this.options.plotOptions?.series || {}),
          connectNulls: true,
        },
      };

      this.checkEmptyState();
      this.reRenderChart();
    }
  }

  ngOnDestroy(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }

  private reRenderChart(): void {
    this.zone.runOutsideAngular(() => {
      if (document.getElementById(this.chartId)) {
        if (this.chartInstance) {
          this.chartInstance.destroy();
        }
        this.chartInstance = Highcharts.chart(this.chartId, this.options);
      }
    });
  }

  private renderChart(): void {
    this.zone.runOutsideAngular(() => {
      if (document.getElementById(this.chartId)) {
        this.chartInstance = Highcharts.chart(this.chartId, this.options);
      }
    });
  }

  /**
   * Show empty state when all series have no data
   */
  private checkEmptyState(): void {
    this.showEmptyState = this.options.series.every(
      (series) => !series.data || series.data.length === 0
    );
  }
}
